import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['arrowButton']

  moveUp(event) {
    const button = event.currentTarget
    const url = button.dataset.url
    this.move(url, button)
  }

  moveDown(event) {
    const button = event.currentTarget
    const url = button.dataset.url
    this.move(url, button)
  }

  move(url, button) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    this.disableAllButtons()

    const icon = button.querySelector('svg')
    const spinner = button.querySelector('.loading')
    if (icon) icon.classList.add('hidden')
    if (spinner) spinner.classList.remove('hidden')

    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          window.location.reload()
        } else {
          this.resetButton(button, icon, spinner)
          this.enableAllButtons()
          this.showFlash(data.message || 'Erro ao mover transformador.', 'error')
        }
      })
      .catch((error) => {
        console.error('Error moving transformer:', error)
        this.resetButton(button, icon, spinner)
        this.enableAllButtons()
        this.showFlash('Erro ao mover transformador.', 'error')
      })
  }

  disableAllButtons() {
    this.arrowButtonTargets.forEach((btn) => {
      btn.disabled = true
      btn.classList.add('opacity-50')
    })
  }

  enableAllButtons() {
    this.arrowButtonTargets.forEach((btn) => {
      btn.disabled = false
      btn.classList.remove('opacity-50')
    })
  }

  resetButton(button, icon, spinner) {
    if (icon) icon.classList.remove('hidden')
    if (spinner) spinner.classList.add('hidden')
  }

  showFlash(message, type) {
    window.showNotification(message, type)
  }
}
